var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCorrect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 6.1A14.002 14.002 0 0016 2C8.268 2 2 8.267 2 16s6.268 14 14 14 14-6.268 14-14a14 14 0 00-4.1-9.9",
    fill: "#068500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.999 22.998l-5.562-5.562 2.828-2.828 2.734 2.734L21.24 9.1l2.828 2.828z"
  }))));
}

export default SvgIconCorrect;